import { formatDate } from 'Utilities'

const s3Url = 'https://s3-ap-northeast-1.amazonaws.com'
const cdnProduction = 'https://triplabot-production.tripla.ai'
const cdnQA = 'https://triplabot.qa.tripla.ai'

export const triplabotVersion = '2.0.1'

export const defaultProductionBaseURL = 'https://concierge.tripla.ai/'

export const termsAndConditionURLForJA = 'https://tripla.io/membership-agreement/'
export const termsAndConditionURL = `https://en.tripla.io/membership-agreement/`

export const privacyPolicyURL = 'https://en.tripla.io/privacy-policy-2/'
export const privacyPolicyURLForJA = 'https://tripla.io/privacy-policy/'

export const maintenanceBaseURL = 'https://maintenance.tripla.ai/'

export const cssURL = _setCssUrl()

export const vueStyleURL = _setCssUrl('style')

export const cssLoaderURL = _setCssLoaderUrl('triplacss')
export const mainScriptURL = _setCssLoaderUrl('tripla')

export const gaTrackingId = _setGaTrackingId(TARGET_ENV)

export const appID = 'tripla-app'

export const noticeWidgetID = 'tripla-maintenance-warning-message'

export const defaultOpName = 'Pakku'

export const defaultOpPosition = 'chatbot'

export const defaultThemeColor = '#ce626c'

export const defaultTextColor = '#fcfcfd'

export const defaultIconSize = 80

export const defaultIconPosition = 10

export const minimumChatWindowHeight = 550

export const maximumChatWindowHeight = 690

export const iframeMaxWidth = 304

export const iframeMaxHeight = 690

export const iframeMaxWidthLeft = 234

export const googleTagJsURL = 'https://www.googletagmanager.com/gtag/js'

export const initialHourIncrement = 1

export const initialMinuteIncrement = 15

export const initialTime = '10:00'

export const chatWindowIframeId = 'tripla-chat-window'

// the format from navigator.language in the browser is different from rails app
// if not found inside localeMapping, default to 'en'
export const localeMapping = {
  'en-US': 'en',
  ja: 'ja',
  ko: 'ko',
  'zh-hans': 'zh_Hans',
  'zh-hant': 'zh_Hant',
  id: 'id',
  th: 'th',
  ar: 'ar'
}

export const availableLanguages = ['en', 'ja', 'ko', 'zh_Hans', 'zh_Hant', 'id', 'th', 'ar']

// will be used on the head styling & the class will be added to the html
export const htmlTriplaClassName = 'tripla-mobile-messenger-active'

// ASSETS URLS
const baseAssetURL = 'https://triplabot-production.tripla.ai/assets/'

export const corporateLogo = 'https://d3ufcf6ekufogm.cloudfront.net/tripla+logo.jpg'

// TODO: below should be inline, only replace when needed. I will add it to SCSS (_layout), please update.
// needs more checking time for pakkuIcon, since it's being used here: src/javascript/ChatWidget/ChatWindow/index.vue
export const pakkuIcon =
  process.env.ENABLE_NEW_DEFAULT_CHAT_ICON === 'true'
    ? `${baseAssetURL}chat-icon-1.png`
    : `${baseAssetURL}chat-message-icon.png`
export const sendButtonImage = `${baseAssetURL}a743fc8872a72d2adeba4ee737a102d7.svg`
export const chatWindowCloseX = `${baseAssetURL}chat-window-close-x.svg`
export const iconLocation = `${baseAssetURL}icon-location.svg`
export const iconCalendar = `${baseAssetURL}icon-calendar.svg`
export const iconPeople = `${baseAssetURL}icon-people.svg`
export const smoking = `${baseAssetURL}icon-smoking-yes.svg`
export const smokingRoom = `${baseAssetURL}smoking_rooms.svg`
export const nonSmokingRoom = `${baseAssetURL}no_smoking_room.svg`
export const nonSmoking = `${baseAssetURL}icon-smoking-no.svg`
export const iconPerson = `${baseAssetURL}icon-person.svg`
export const iconAdult = `${baseAssetURL}person.svg`
export const iconMail = `${baseAssetURL}icon-mail.svg`
export const iconPhone = `${baseAssetURL}icon-phone.svg`
export const iconWifi = `${baseAssetURL}wifi.svg`
export const iconMeal = `${baseAssetURL}meal.svg`
export const poweredByLogos = {
  gurunavi: `${baseAssetURL}gurunavi_logo.png`
}
export const placeholderImage = `${baseAssetURL}placeholder.jpg`
export const iconToday = `${baseAssetURL}today-green.svg`
export const iconClock = `${baseAssetURL}access-time-green.svg`
export const iconCloseBlack = `${baseAssetURL}close-black.svg`
export const iconMessageSend = `${baseAssetURL}icon-message-send.svg`
export const touristImgPlaceholder = `${baseAssetURL}tourist_attraction_placeholder.jpg`

export const iconMapping = {
  'icon-people': iconPeople,
  'icon-smoking-yes': smokingRoom,
  'icon-smoking-no': nonSmokingRoom,
  'icon-person': iconAdult,
  'icon-wifi': iconWifi,
  'icon-meal': iconMeal
}

export const messageType = {
  creditCard: 'credit_card'
}

export const defaultStartDate = formatDate(new Date(), 'yyyy-MM-dd')
export const defaultEndDate = formatDate(
  new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
  'yyyy-MM-dd'
)

// PRIVATE FUNCTIONS INSIDE CONSTANTS
function _setCssUrl(fileName = 'index') {
  switch (TARGET_ENV) {
    case 'production':
      return `${cdnProduction}/${fileName}.css`
    case 'qa':
      return `${cdnQA}/${fileName}.css`
    case 'staging':
      return `${s3Url}/triplabot-staging/${fileName}.css`
    case 'devbuild':
      return `http://localhost:8080/dist/${fileName}.css`
    default:
      // for development environtment
      return `/dist/index.css`
  }
}

function _setCssLoaderUrl(fileName = 'triplacss') {
  switch (TARGET_ENV) {
    case 'production':
      return `${cdnProduction}/${fileName}.min.js`
    case 'qa':
      return `${cdnQA}/${fileName}.min.js`
    case 'staging':
      return `${s3Url}/triplabot-staging/${fileName}.min.js`
    case 'devbuild':
      return `http://localhost:8080/dist/${fileName}.min.js`
    default:
      // for development environtment
      return `/dist/${fileName}.min.js`
  }
}

export function appCode() {
  const productionAppCode = 'd9721f9f9daea3fb2c8c71752b510b52'
  const testingAppCode = '1dc1f3d78c2866e5356cd9fd7e78148b'
  return TARGET_ENV === 'production' ? productionAppCode : testingAppCode
}

export function getSearchWidgetUrl(fileName) {
  const path = `SearchBar/${fileName}`
  switch (TARGET_ENV) {
    case 'production':
      return `${cdnProduction}/${path}`
    case 'qa':
      return `https://searchbar.qa.tripla.ai/${path}`
    case 'staging':
      return `${s3Url}/triplabot-staging/${path}`
    default:
      // for development environtment
      return 'http://localhost:8093/tripla-search-bar.min.js'
  }
}

function _setGaTrackingId(environment) {
  switch (environment) {
    case 'production':
      return 'UA-118751264-5'
    case 'staging':
      return 'UA-118751264-4'
    default:
      // for development environtment
      return ''
  }
}

export function getS3Url() {
  switch (TARGET_ENV) {
    case 'production':
      return `${cdnProduction}/`
    case 'qa':
      return `https://searchbar.qa.tripla.ai/`
    case 'staging':
      return `${s3Url}/triplabot-staging/`
    default:
      // for development environtment
      return `${s3Url}/triplabot-review/`
  }
}

const bookingWidgetServer = {
  staging: 'https://bw.staging.tripla.ai',
  qa: 'https://bw.qa.tripla.ai',
  development: 'http://localhost:8091',
  devbuild: 'http://localhost:8091',
  production: 'https://bw.tripla.ai'
}

export default function getBookingWidgetServerUrl() {
  if (window.triplaSubdomainBwURL) {
    return window.triplaSubdomainBwURL
  }
  const host = location.host
  let url = bookingWidgetServer.production

  if (bookingWidgetServer[TARGET_ENV]) {
    url = bookingWidgetServer[TARGET_ENV]
  } else {
    if (host.includes('staging')) {
      url = bookingWidgetServer.staging
    } else if (host.includes('qa')) {
      url = bookingWidgetServer.qa
    }
  }
  return url
}

export const ThirdPartyPayment = {
  GMO: 'gmo',
  GMOPayPal: 'gmo-paypal',
  Paygent: 'paygent',
  PayPal: 'paypal'
}

export const triplabotSettingAttributes = [
  'data-triplabot-code',
  'data-triplabot-base-url',
  'data-triplabot-pubnub-base-url',
  'data-triplabot-draggable',
  'data-triplabot-restaurant-code'
]

export const UPLOAD_FILE_SIZE_LIMIT = 10 * 1024 * 1024
export const MAX_FILES_UPLOAD_AT_ONCE = 5
export const supportedUploadImageTypes = ['bmp', 'png', 'jpg', 'jpeg', 'gif']
export const supportedUploadDocTypes = [
  'pdf',
  'csv',
  'txt',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx'
]

export const LocalStorageKeys = {
  LOCALE: 'triplabot_locale',
  CHAT_TOKEN: 'triplabot_token',
  LAST_CHAT_EVALUADTED_AT: 'triplabot_last_chat_evaluated_at',
  SELECTED_CHAT_CHANNEL: 'triplabot_chat_channel',
  CLOSED_ICON_MESSAGES: 'closed_icon_message_ids',
  CHAT_ICON_MINIZED: 'triplabot-icon-minimized',
  COOKIE_PREFERENCES: 'triplabot_cookie_preferences',
  TERMS_CONDITIONS_ACCEPTED: 'terms_conditions_accepted'
}

export const SessionStorageKeys = {
  RESTAURENT_CODE: 'triplabot_restaurant_code',
  TEMP_TRIPLA_UID: 'temp_tripla_uid'
}

export const CookieKeys = {
  BW_ORG_SIGNED_IN: 'triplabot_bw_org_signed_in'
}

export const ChatChannels = {
  MESSENGER: 'facebook',
  LINE: 'line',
  WEB: 'web',
  WHATSAPP: 'whatsapp'
}

export const CookieTypes = {
  NECESSARY: 'necessary',
  FUNCTIONAL: 'functional',
  PERFORMANCE: 'performance',
  ADVERTISING: 'advertising'
}

export const CURRENCY_SYMBOL_MAP = {
  KRW: '₩',
  JPY: '¥',
  TWD: 'NT$'
}
